import { useMutation, useQueryClient } from "@tanstack/react-query";
import { merchantKeys } from "Api/Queries/Merchants/useGetMerchantQuery";
import {
  type MerchantFeeDto,
  putMerchantsPublicIDFees,
  type UpdateMerchantFeeDto,
} from "Infrastructure/Api/Api";
import { processResponseWithApiProblemDetails } from "Infrastructure/Api/ApiUtils";

type Parameters = { data: UpdateMerchantFeeDto; publicID: string };

type Props = {
  onSuccess?: (publicID: string) => void;
  onError?: () => void;
};

export const useUpdateMerchantFees = ({ onSuccess, onError }: Props = {}) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: processResponseWithApiProblemDetails(
      ({ data, publicID }: Parameters) =>
        putMerchantsPublicIDFees(data, publicID),
    ),
    onSuccess: (data: MerchantFeeDto, { publicID }: Parameters) => {
      queryClient.invalidateQueries({
        queryKey: merchantKeys.byMerchantPublicId(publicID),
      });
      onSuccess?.(data.publicID);
    },
    onError,
  });
};
